import {compose} from 'redux'
import {connect} from 'react-redux'
import injectReducer from 'utils/injectReducer'
import reducer from './reducer'
import {
  loadGeoInfo,
  loadGeoSuggest,
  updateGeoInfo,
  updateGeoSuggest
} from './actions'

const mapStateToProps = (state) => ({geo: state.geo})

function mapDispatchToProps(dispatch) {
  return {
    loadGeoInfo: (id) => dispatch(loadGeoInfo(id)),
    cacheGeoInfo: (id, name) => dispatch(updateGeoInfo({id, name})),
    loadGeoSuggest: (search, type) => dispatch(loadGeoSuggest(search, type)),
    cancelGeoSuggest: () => dispatch(updateGeoSuggest(null))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({key: 'geo', reducer})

export default compose(withReducer, withConnect)
